import React from 'react'
import { Card } from 'antd'
import '../../components/biils/Managebills.css'
import TableViewNoContext from '../../components/biils/TableViewNoContext'

const TablesBillsNoContext = ({
  tables,
  getActiveBillsForTable,
  createBill,
  billModalState,
  setBillModalState,
  getTableById,
  deleteBill,
  getBillTotal,
  mergeTables,
  mergeBillsInTable,
  splitBill,
  updateBillItems,
  updateBillMeta,
  closeBill,
  refreshBillsForTable,
}) => {
  return (
    <Card>
      <TableViewNoContext
        tables={tables}
        getActiveBillsForTable={getActiveBillsForTable}
        createBill={createBill}
        billModalState={billModalState}
        setBillModalState={setBillModalState}
        getTableById={getTableById}
        deleteBill={deleteBill}
        getBillTotal={getBillTotal}
        mergeTables={mergeTables}
        mergeBillsInTable={mergeBillsInTable}
        splitBill={splitBill}
        updateBillItems={updateBillItems}
        updateBillMeta={updateBillMeta}
        closeBill={closeBill}
        refreshBillsForTable={refreshBillsForTable}
      />
    </Card>
  )
}

export default TablesBillsNoContext